import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  approveRwoMedia,
  deleteDwoMedia,
  deleteRwoMedia,
  getMediaUploaded,
  rejectRwoMedia,
  updateDwoMediaStatus,
} from "src/redux/api/_hr_attendance.api";
import { toast } from "react-toastify";
import { MediaItem } from "../types/dailyTaskRwo";
import { dwoTaskKeys } from "./useDailyTaskDwo";
import { rwoTaskKeys } from "./useDailyTaskRwo";
import { dwoTaskListKeys } from "./useDwoTaskList";

export const useGetMedia = (attendanceId: string) =>
  useQuery<MediaItem[]>({
    queryKey: ["hr-media", attendanceId],
    queryFn: () => getMediaUploaded(attendanceId),
    enabled: !!attendanceId,
  });

export const useDeleteDwoMedia = (attendanceId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (mediaId: string) => deleteDwoMedia(mediaId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: dwoTaskKeys.list(attendanceId),
      });

      toast.success("Media deleted.");
    },
    onError: () => toast.error("Failed to delete media."),
  });
};

export const useDwoMediaStatus = (attendanceId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      mediaId,
      status,
    }: {
      mediaId: string;
      status: "APPROVED" | "REJECTED";
    }) => updateDwoMediaStatus(mediaId, status),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: dwoTaskKeys.list(attendanceId),
      });
      queryClient.invalidateQueries({
        queryKey: dwoTaskListKeys.all,
      });
    },
    onError: () => toast.error("Failed to update status."),
  });
};

export const useDeleteRwoMedia = (attendanceId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (mediaId: string) => deleteRwoMedia(mediaId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: rwoTaskKeys.list(attendanceId),
      });
      toast.success("Media deleted.");
    },
    onError: () => toast.error("Failed to delete media."),
  });
};

export const useApproveRwoMedia = (attendanceId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ mediaId }: { mediaId: string }) => approveRwoMedia(mediaId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: rwoTaskKeys.list(attendanceId),
      });
    },
    onError: () => toast.error("Failed to update status."),
  });
};

export const useRejectRwoMedia = (attendanceId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ mediaId }: { mediaId: string }) => rejectRwoMedia(mediaId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: rwoTaskKeys.list(attendanceId),
      });
    },
    onError: () => toast.error("Failed to update status."),
  });
};
